/**
 * C3 长图/横宽产物的「作品 vs 附属」口径(展示层单一源)。
 *
 * 长图任务的资产集 = **整图**(seq=1)+ 逐块**分段**(assetMeta.segment=true)。
 * 分段是附属产物,只服务于分段面板的单块重出/局部导出 —— 不是独立作品。
 *
 * 后端早已按同口径处理列表封面与成败计数(`PosterService.isLongImageSegment`:
 * 分段不入封面、不入 success/failed 计数),详情页此前没跟上,于是同一件作品在详情页
 * 被显示成 N 件、默认还选中末段(用户实锤:「详情图是分开的各张图片」)。
 */

interface AssetLike {
  seq: number;
  status?: string | null;
  segment?: boolean | null;
}

/** 展示集:长图只留整图;非长图原样(常规海报没有分段概念)。 */
export function displayableAssets<T extends AssetLike>(assets: T[], isLongImage: boolean): T[] {
  return isLongImage ? assets.filter((a) => a.segment !== true) : assets;
}

/**
 * 整图:展示集里 seq 最大的 SUCCESS —— 首次交付 seq=1,整图重出会取 max(seq)+1,
 * 取最大即「最新那版整图」。没有成功整图(生成中/失败)→ null。
 */
export function pickFullImage<T extends AssetLike>(displayAssets: T[]): T | null {
  let best: T | null = null;
  for (const a of displayAssets) {
    if (a.status === "SUCCESS" && (best == null || a.seq > best.seq)) best = a;
  }
  return best;
}
